import { render, staticRenderFns } from "./CollaboratorDetails.vue?vue&type=template&id=13e81493&"
import script from "./CollaboratorDetails.vue?vue&type=script&lang=js&"
export * from "./CollaboratorDetails.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports